import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const LOGO_PARKING = 'https://www.parking.net.co/static/media/logo-parking.1b966e24b3437ec7b680.png';

export default function TerminosyCondicionesMundial() {
  return (
    <>
      <Container className="mtop-30 tyc-container tyc-mundial">
        <Row className="justify-content-center mtop-20 mbottom-20">
          <Col xs={12}>
            <div className="tyc-header">
              <div className="tyc-header-logo">
                <img src={LOGO_PARKING} alt="Parking" />
              </div>
              <div className="tyc-header-text">
                <h1>Términos y Condiciones para la campaña "Vive el Mundial con Be Parking"</h1>
                <p className="tyc-meta">
                  <span>Versión: 01</span>
                  <br />
                  <span>Fecha: febrero 2026</span>
                </p>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <article className="tyc-body">
              <h3>1. Organizador</h3>
              <p>La presente campaña es organizada Parking International S.A.S. (en adelante "Parking").</p>

              <h3>2. Definiciones</h3>
              <p>A continuación, se definen las palabras clave de esta Campaña:</p>
              <ul>
                <li><strong>Activaciones presenciales:</strong> Acciones promocionales realizadas físicamente por el programa Be Parking en determinados parqueaderos de su red durante la vigencia de la campaña, las cuales pueden incluir dinámicas como la ruleta, entrega de premios y registro de clientes, y que son operadas por personal autorizado.</li>
                <li><strong>BeParking:</strong> programa de fidelización operado por Parking International S.A.S., a través del cual los clientes afiliados acumulan puntos, reciben beneficios y participan en campañas promocionales conforme a los términos y condiciones vigentes.</li>
                <li><strong>Cliente afiliado:</strong> Persona natural que se ha registrado de manera válida en el programa de fidelización Be Parking, cuenta con un perfil activo en el sistema y se identifica mediante su número de cédula u otro documento válido.</li>
                <li><strong>Promotor:</strong> Persona designada y autorizada por Be Parking o por la agencia aliada para ejecutar las activaciones presenciales, verificar la afiliación de los clientes, registrar la entrega de premios y asegurar el correcto desarrollo de la campaña.</li>
                <li><strong>Visita:</strong> Transacción real y válida realizada por un cliente afiliado en cualquiera de los parqueaderos de la red Parking, que quede debidamente registrada en los sistemas de la compañía y que genere puntaje conforme a las reglas del programa de fidelización.</li>
                <li><strong>Visita fraudulenta:</strong> Cualquier visita, transacción o registro que no corresponda a una operación real de parqueo, que sea duplicada, manipulada, simulada o registrada con el fin de obtener beneficios indebidos, y que no pueda ser validada por los sistemas.</li>
              </ul>

              <h3>3. Vigencia</h3>
              <p>La campaña estará vigente desde el 23 de febrero de 2026 hasta el 23 de abril de 2026, ambas fechas inclusive.</p>
              <p>Las visitas, registros o participaciones realizadas por fuera de este periodo no serán tenidas en cuenta.</p>

              <h3>4. Participantes</h3>
              <p>Podrán participar todas las personas que sean clientes afiliados a Be Parking.</p>

              <h3>5. Ciudades participantes</h3>
              <p>La campaña aplica para toda la red de parqueaderos en la ciudad de Bogotá.</p>

              <h3>6. Mecánica de la campaña</h3>

              <h4>6.1. Requisito obligatorio para participar por el premio principal</h4>
              <p>Para participar por el premio mayor de experiencia, los clientes deberán cumplir obligatoriamente con el siguiente proceso durante la vigencia de la campaña:</p>
              <ol>
                <li>Escanear el código QR oficial dispuesto en los parqueaderos Be Parking.</li>
                <li>Diligenciar el formulario habilitado ingresando:</li>
                <li>Número de cédula con el cual se encuentra afiliado a Be Parking.</li>
                <li>Tener un mínimo de 3 transacciones durante el periodo de la campaña pagados.</li>
                <li>Número de factura de la transacción realizada.</li>
                <li>Solo participarán las facturas que se encuentren debidamente registradas y validadas en el sistema Be Parking.</li>
                <li>No se aceptarán facturas:</li>
                <li>Anteriores al inicio de la campaña.</li>
                <li>Posteriores a la finalización de la campaña.</li>
                <li>Que no correspondan a transacciones reales.</li>
                <li>Que no estén asociadas a un cliente afiliado.</li>
                <li>Cada factura podrá registrarse una única vez. Be Parking podrá invalidar registros duplicados, erróneos o fraudulentos.</li>
              </ol>
              <p>Espera 30 minutos después de tu transacción para que la factura aparezca en el sistema. Luego regístrala y participa por la experiencia de ver el partido.</p>

              <h4>6.2. Criterio de selección del ganador del premio principal</h4>
              <p>En ningún caso, el premio principal se asignará mediante sorteo. Será ganador el Cliente Afiliado que:</p>
              <ul>
                <li>Haya registrado correctamente sus facturas durante el período de la campaña a través del código QR ubicado en los parqueaderos.</li>
                <li>Tenga un mínimo de 3 transacciones registradas dentro de la vigencia de la Campaña de facturas pagadas.</li>
                <li>Obtenga el mayor puntaje acumulado en el programa de fidelización Be Parking durante la vigencia de la campaña.</li>
              </ul>
              <p>El puntaje se calculará exclusivamente con base en:</p>
              <ul>
                <li>Transacciones válidas.</li>
                <li>Facturas registradas dentro del periodo de la campaña.</li>
                <li>Las reglas vigentes del programa de fidelización Be Parking.</li>
                <li>No se tendrán en cuenta puntos generados por transacciones anteriores o posteriores a la vigencia de la campaña.</li>
              </ul>
              <p><strong>Desempate</strong></p>
              <p>En caso de empate en el puntaje acumulado entre dos o más participantes, Be Parking elegirá al cliente con mayor número de facturas válidas registradas durante la vigencia de la Campaña.</p>

              <h3>7. Activaciones presenciales y premios de menor cuantía</h3>
              <p>Durante la vigencia de la campaña, Be Parking realizará activaciones presenciales en aproximadamente seis (6) parqueaderos.</p>
              <p>Estas activaciones contarán con una ruleta física de participación en cada uno de los parqueaderos.</p>
              <p>La participación en la ruleta será voluntaria, sin relación directa con el puntaje acumulado para el premio principal.</p>

              <h4>7.1. Requisito obligatorio para participar en la ruleta:</h4>
              <ul>
                <li>El cliente debe estar afiliado a Be Parking.</li>
                <li>El personal encargado de la activación verificará la afiliación del cliente antes de permitir su participación.</li>
              </ul>

              <h3>8. Premios</h3>

              <h4>8.1. Premio principal</h4>
              <ul>
                <li>Tres (3) cupónes por COP$1.000.000 para máximo cuatro (4) adultos para consumo en establecimiento de comercio donde se podrá ver un (1) partido del mundial de fútbol, que tendrá lugar entre el 11 de junio de 2026 y 19 de julio de 2026.</li>
                <li>El establecimiento de comercio donde se podrá redimir el cupón será elegido por Parking.</li>
                <li>El premio no es canjeable por dinero en efectivo, ni transferible, ni acumulable con otras promociones.</li>
              </ul>

              <h4>8.2. Premios de menor cuantía</h4>
              <p>Los premios que podrán obtenerse a través de la ruleta, sujetos a disponibilidad, son:</p>
              <ul>
                <li>Bonos sorpresa, que pueden bonos de gasolina, helado etc por valor de hasta $10.000 COP.</li>
                <li>Termos oficiales Be Parking.</li>
                <li>50 puntos Be Parking, los cuales serán cargados directamente al perfil del Cliente Afiliado.</li>
                <li>100 puntos Be Parking, los cuales serán cargados directamente al perfil del Cliente Afiliado.</li>
              </ul>
              <p>Los puntos se verán reflejados en un plazo máximo de 8 días hábiles. Los puntos acumulados podrán consultarse en www.beparking.com.co o a través de la línea de servicio al cliente 312 450 7484 (Bogotá) y 300 910 9787, de lunes a viernes, de 8:00 a. m. a 5:30 p. m.</p>
              <p>Los premios se entregarán hasta agotar existencias. Be Parking no garantiza la disponibilidad permanente de todos los premios durante toda la vigencia de la Campaña.</p>

              <h4>8.3. Condiciones para la entrega por ruleta</h4>
              <p>La participación en la ruleta es voluntaria y está sujeta a disponibilidad de premios en cada parqueadero o punto de servicio Parking.</p>
              <p>Para participar, el cliente debe estar afiliado a Be Parking, condición que será verificada por el personal autorizado en el punto de activación.</p>
              <p>Los premios se entregan de forma presencial, en el mismo momento de la activación, mediante bono físico, con excepción del termo, que será entregado en físico.</p>
              <p>Cada cliente ganador será registrado por el promotor, quien recolectará los siguientes datos personales:</p>
              <ul>
                <li>Nombre completo</li>
                <li>Número de cédula</li>
                <li>Firma del cliente como constancia de entrega del premio</li>
              </ul>
              <p>Los premios se entregan hasta agotar existencias. En caso de no contar con un premio específico, Parking podrá entregar otro premio disponible de valor equivalente, sin que ello genere derecho a reclamación.</p>

              <h4>8.4. Condiciones de los 50 y 100 puntos Be Parking</h4>
              <p>Los puntos Be Parking serán cargados directamente al perfil del cliente afiliado.</p>
              <p>El cliente deberá tener en cuenta que los puntos podrán verse reflejados en su perfil hasta dentro de un plazo máximo de ocho (8) días hábiles posteriores a la entrega del premio.</p>
              <p>Los puntos no son transferibles ni canjeables por dinero en efectivo.</p>
              <p>La acumulación y redención de puntos se rige por los términos generales del programa Be Parking.</p>

              <h4>8.5. Condiciones de entrega de los termos</h4>
              <p>Los termos se entregan de forma física e inmediata, en el punto de activación.</p>
              <p>La entrega está sujeta a disponibilidad de inventario.</p>
              <p>En caso de agotarse los termos, Be Parking podrá entregar otro premio disponible de valor equivalente.</p>
              <p>El premio no es canjeable por dinero ni por otros productos.</p>

              <h4>8.6. Condiciones de los bonos sorpresa</h4>
              <p>Cualquiera de los premios sorpresa que se entreguen, el personal encargado de la entrega indicará según el premio otorgado las condicionales para su redención. Vigencia.</p>

              <h4>8.7. Control y validación de entrega</h4>
              <p>La entrega de premios será validada mediante:</p>
              <ul>
                <li>Registro y firma del cliente ganador</li>
                <li>Número de documento de identidad del cliente ganador</li>
                <li>Esta información será utilizada únicamente como soporte de entrega y control interno de la campaña.</li>
              </ul>

              <h3>9. Notificación del ganador del premio principal</h3>
              <ul>
                <li>El ganador será contactado a través de los datos registrados en su afiliación Be Parking.</li>
                <li>En caso de que el ganador no responda o no acepte el premio dentro del plazo informado, Be Parking podrá asignar el premio al siguiente participante con mayor puntaje acumulado.</li>
              </ul>

              <h3>10. Restricciones</h3>
              <ul>
                <li>No podrán participar colaboradores directos de Parking ni de las agencias de mercadeo vinculadas a la campaña.</li>
                <li>No se tendrán en cuenta visitas fraudulentas, duplicadas o que no correspondan a transacciones reales.</li>
                <li>Be Parking se reserva el derecho de descalificar a cualquier participante que intente manipular o alterar la mecánica de la campaña.</li>
              </ul>

              <h3>11. Modificaciones</h3>
              <p>Be Parking podrá modificar, suspender o cancelar la campaña por razones operativas, técnicas o comerciales, informándolo por sus canales oficiales.</p>

              <h3>12. Aceptación</h3>
              <p>La participación en la campaña implica el conocimiento y aceptación total de estos términos y condiciones.</p>

              <h3>13. Otras disposiciones</h3>
              <ul>
                <li>En caso de contradicción entre piezas publicitarias y los presentes términos y condiciones, prevalecerá lo dispuesto en este documento.</li>
                <li><strong>Fuerza mayor y caso fortuito:</strong> Parking no será responsable por el incumplimiento o imposibilidad de ejecución de la campaña cuando ello obedezca a eventos de fuerza mayor o caso fortuito, incluyendo, pero sin limitarse a, cierres de parqueaderos, fallas de servicios públicos, decisiones de autoridad competente o eventos de orden público.</li>
                <li><strong>Limitación de responsabilidad:</strong> En ningún caso, Parking será responsable por daños indirectos, lucro cesante o perjuicios consecuenciales derivados de la participación en la campaña, sin perjuicio de los derechos irrenunciables del consumidor previstos en la Ley 1480 de 2011.</li>
              </ul>

              <h3>14. Participación en campañas simultáneas</h3>
              <p>
                El participante podrá participar de manera simultánea en otras campañas, promociones o actividades comerciales vigentes organizadas por Parking, 
                incluyendo aquellas que se desarrollen en paralelo a la campaña del Mundial, siempre y cuando cumpla con los requisitos, mecánicas y condiciones 
                específicas de cada una. La participación en campañas adicionales no afectará su elegibilidad en esta promoción, salvo que se indique lo contrario 
                en los términos particulares correspondientes.
              </p>
            </article>
          </Col>
        </Row>
      </Container>
    </>
  );
}
